export default "__VITE_ASSET__9f2723a6__"